<template>
  <form-field
    :label="label"
    :validation-errors="validationErrors"
    :label-for="forId"
    :help-text="helpText"
  >
    <b-timepicker
      :id="forId"
      v-bind="$attrs"
      :class="classAttr"
      icon="clock"
      size="is-small"
      :inline="isInline"
      :value="date"
      hour-format="12"
      locale="en-US"
      @input="handleInput"
      expanded
      :mobile-native="false"
      :default-minutes="0"
    ></b-timepicker>
  </form-field>
</template>

<script>

export default {
  name: "FormFieldTimePicker",
  props: {
    value: {
      type: [Array, String, Number, Boolean, Date]
    },
    label: {
      type: String,
    },
    validationErrors: {
      type: Array,
      default: () => []
    },
    isInline: {
      type: Boolean,
      default: false
    },
    classAttr: {
      type: String,
      default: ''
    },
    helpText: {
      type: String
    },
    type: {
      type: String,
      required: true,
      /**
       * timestamp:  2021-03-11T21:37:55.000000Z
       *  datetime:  2021-03-11 21:37:55
       *      date:  2021-03-11
       *      time:  21:37
       *    jsDate:  new Date()   as Javascript Date Object
       */
      validator: function (value) {
        return ['time', 'jsDate'].indexOf(value) !== -1
        // return ['timestamp', 'date', 'time', 'datetime', 'jsDate'].indexOf(value) !== -1
      }
    }
  },
  data() {
    return {
      forId: this.$utils.generateClientId(),
      date: new Date(),
    }
  },
  mounted() {
    this.setValue(this.value);
  },
  watch: {
    value: function (value) {
      this.setValue(value);
    },
  },
  methods: {
    setValue(value) {
      if (value === null) {
        return this.date = null;
      }

      if (this.type === 'time') {
        this.date = this.$utils.timeStringWithoutTimezoneToDate(value);
      } else if (this.type === 'jsDate') {
        this.date = value;
      } else {
        throw Error('Date type not yet implemented');
      }
    },
    handleInput(date) {
      let value = null;

      if (this.type === 'time') {
        value = this.$utils.dateToTimeStringWithoutTimezone(date);
      } else if (this.type === 'jsDate') {
        value = date;
      } else {
        throw Error('Date type not yet implemented');
      }

      this.$emit('input', value);
      this.$emit('change', value);
      this.$emit('selected', value);

      this.date = date;
    }
  }
}
</script>

<style scoped>

</style>
